<form #form="ngForm">
  <div class="form-row">
    <div class="form-group col-md-4" id="parentGuardian-firstName">
      <label for="firstName">First Name</label>
      <input
        type="text"
        class="form-control"
        id="firstName"
        name="firstName"
        maxlength="80"
        [(ngModel)]="parentGuardian.firstName"
        required
        #firstName="ngModel">
      <control-errors [control]="firstName" name="First Name"></control-errors>
    </div>
    <div class="form-group col-md-4" id="parentGuardian-lastName">
      <label for="lastName">Last Name</label>
      <input
        type="text"
        class="form-control"
        id="lastName"
        name="lastName"
        maxlength="60"
        [(ngModel)]="parentGuardian.lastName"
        required
        #lastName="ngModel">
      <control-errors [control]="lastName" name="Last Name"></control-errors>
    </div>
    <div class="form-group col-md-4" id="parentGuardian-lastName">
      <label for="relationshipTypeDTOID">Relationship</label>
      <select
        class="form-control form-select"
        name="relationshipTypeDTOID"
        id="relationshipTypeDTOID"
        [(ngModel)]="parentGuardian.relationshipTypeDTOID"
        required
        #relationshipTypeDTOID="ngModel"
      >
        <option class="form-control form-select" *ngFor="let relationship of relationships" [ngValue]="relationship.id">{{relationship.description}}</option>
      </select>
      <div *ngIf="relationshipTypeDTOID.touched && relationshipTypeDTOID.invalid" class="invalid-feedback">
        Relationship is required
      </div>
    </div>
  </div>
  <div class="form-row">
    <div class="form-group col-md-6" id="parentGuardian-address1">
      <label for="address1">Address</label>
      <input
        type="text"
        class="form-control"
        name="address1"
        id="address1"
        maxlength="80"
        [(ngModel)]="parentGuardian.address1"
        required
        #address1="ngModel">
      <control-errors [control]="address1" name="Address"></control-errors>
    </div>
    <div class="form-group col-md-6">
      <label for="address2">Apt., Suite, Unit (optional)</label>
      <input
        type="text"
        class="form-control"
        name="address2"
        id="address2"
        maxlength="80"
        [(ngModel)]="parentGuardian.address2"
        #address2="ngModel"
      >
    </div>
  </div>
  <div class="form-row">
    <div class="form-group col-md-3" id="parentGuardian-postalCode">
      <label for="postalCode">Zip Code</label>
      <input
        type="text"
        class="form-control"
        name="postalCode"
        id="postalCode"
        maxlength="5"
        [pattern]="zipValidator"
        [(ngModel)]="parentGuardian.postalCode"
        required
        #postalCode="ngModel">
      <control-errors [control]="postalCode" name="Zip Code"></control-errors>
    </div>
    <div class="form-group col-md-6" id="parentGuardian-city">
      <label for="city">City</label>
      <input
        type="text"
        class="form-control"
        name="city"
        id="city"
        maxlength="60"
        [(ngModel)]="parentGuardian.city"
        required
        #city="ngModel">
      <control-errors [control]="city" name="City"></control-errors>
    </div>
    <div class="form-group col-md-3" id="parentGuardian-state">
      <label for="state">State</label>
      <select
        class="form-control form-select"
        name="state"
        id="state"
        [(ngModel)]="parentGuardian.state"
        required
        #state="ngModel"
      >
        <option class="form-control form-select" *ngFor="let state of states" [ngValue]="state.name">{{state.description}}</option>
      </select>
      <div *ngIf="state.touched && state.invalid" class="invalid-feedback">
        State is required
      </div>
    </div>
  </div>
  <div class="form-row">
    <div class="form-group col-md-6" id="parentGuardian-phoneNumber">
      <label for="phoneNumber">Cell Phone Number</label>
      <input
        type="text"
        mask="000-000-0000"
        placeholder="111-111-1111"
        class="form-control"
        id="phoneNumber"
        name="phoneNumber"
        [pattern]="phoneValidator"
        [(ngModel)]="parentGuardian.phoneNumber"
        required
        #phoneNumber="ngModel">
      <control-errors [control]="phoneNumber" name="Phone Number"></control-errors>
      <p class="input-annotation">You will receive texts and calls at this number about this event and upcoming LLS events, fundraisers, and offerings. You will have the ability to opt out once communication begins.</p>
      <input
        type="hidden"
        id="phoneTypeName"
        name="phoneTypeName"
        [(ngModel)]="parentGuardian.phoneTypeName"
        #phoneTypeName="ngModel">
    </div>
    <div class="form-group col-md-6" id="parentGuardian-emailAddress">
      <label for="emailAddress">Email Address</label>
      <input
        type="email"
        class="form-control"
        id="emailAddress"
        name="emailAddress"
        maxlength="255"
        [(ngModel)]="parentGuardian.emailAddress"
        email
        required
        #emailAddress="ngModel">
      <control-errors [control]="emailAddress" name="Email Address"></control-errors>
    </div>
  </div>
  <div class="form-row">
    <div class="form-group col-md-6">
      <label for="companyName">Employer</label>
      <input
        type="text"
        class="form-control"
        id="companyName"
        name="companyName"
        maxlength="100"
        [(ngModel)]="parentGuardian.companyName"
        required
        #companyName="ngModel"
      >
      <control-errors [control]="companyName" name="Employer"></control-errors>
    </div>
    <div class="form-group col-md-6">
      <label for="jobTitle">Job Title/Role</label>
      <input
        type="text"
        class="form-control"
        id="jobTitle"
        name="jobTitle"
        maxlength="50"
        [(ngModel)]="parentGuardian.jobTitle"
        required
        #jobTitle="ngModel"
      >
      <control-errors [control]="jobTitle" name="Job Title/Role"></control-errors>
    </div>
  </div>
</form>
